import React, { FC, useMemo } from 'react'
import {
  ESportsCodes,
  selectMainOutcomeTypes,
  selectSport
} from 'astra-core/containers/CommonDataProvider'
import {
  OutcomeType,
  EventProbability,
  ParameterType
} from 'betweb-openapi-axios'
import { getOutcomeParameterValue } from 'astra-core'

import { useAppSelector } from 'store'
import { EventCoefficientTotal } from 'entities/event'

import { useGetTotalValue } from '../../lib'

type Props = Pick<Parameters<typeof useGetTotalValue>[0], 'event'> &
  Pick<Parameters<typeof useGetTotalValue>[0], 'totalOutcomeType'> & {
    hotProbs: Record<OutcomeType['id'], EventProbability>
  }

export const EventRowCoefficientTotalV2: FC<Props> = ({
  event,
  totalOutcomeType,
  hotProbs
}) => {
  const mainOutcomeTypes = useAppSelector(selectMainOutcomeTypes)
  // const value = useGetTotalValue({ event, totalOutcomeType })
  const value = useMemo(
    () =>
      getOutcomeParameterValue({
        eventProbability: hotProbs[mainOutcomeTypes[totalOutcomeType]!],
        parameterType: ParameterType.Value
      }),
    [totalOutcomeType, mainOutcomeTypes, hotProbs]
  )

  const { code: sportCode } =
    useAppSelector((state) => selectSport(state, event.tournament.sportId)) ||
    {}

  return (
    <EventCoefficientTotal
      sportCode={sportCode as ESportsCodes}
      value={value}
    />
  )
}
